import { useTranslation } from 'react-i18next';

import Typography from 'components/global/Typography';

import * as S from '../SubscriptonAccountModal.styled';

const MonthlyFreeIntegratorShipments = ({ pricingPackage }) => {
	const { t } = useTranslation();
	return (
		<div className="my-3">
			<S.InlineTypography>
				<Typography variant="caption" fontWeight="bold" noWrap>
					{pricingPackage.monthlyFreeIntegratorOrder} {t('freeShipment')}
				</Typography>
				<Typography variant="caption" color="var(--content-3)" noWrap className="mx-1">
					/
				</Typography>
				<Typography variant="caption" color="var(--content-3)" noWrap>
					upgradeAccountPage.monthlyYourOwnRates
				</Typography>
				<Typography variant="caption" color="var(--content-3)" noWrap className="mx-1">
					,
				</Typography>
				<Typography variant="caption" fontWeight="bold" noWrap>
					{pricingPackage.extraOrderCost} {t(pricingPackage.currency)}
				</Typography>
				<Typography variant="caption" color="var(--content-3)" noWrap>
					/{t('extraShipment')}
				</Typography>
			</S.InlineTypography>
		</div>
	);
};

export default MonthlyFreeIntegratorShipments;
